<template>
  <div class="h-20 flex justify-center items-center text-sm">
    <router-link v-if="isMobile" to="/privacy" class="no-underline">Privacy</router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageFooter',

  computed: {
    ...mapState(['isMobile']),
  },
}
</script>

<style scoped lang="stylus">
</style>
